import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import AlmondImg from '../assets/banners/almonds.jpg';
import { FaHeart, FaBrain, FaGlobeAsia, FaBox } from 'react-icons/fa';

const Almond = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Almond Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your almonds.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-orange-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-orange-700 mb-4">Premium Almonds</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Nutrient-rich almonds packed with flavor, perfect for snacking, cooking, gifting & exporting worldwide.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={AlmondImg}
                        alt="Almonds"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-orange-700 mb-6">Why Choose Our Almonds?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaHeart className="text-orange-600 mt-1" />High in healthy fats & antioxidants for heart health</li>
                        <li className="flex items-start gap-3"><FaBrain className="text-orange-600 mt-1" />Excellent source of Vitamin E and brain-boosting nutrients</li>
                        <li className="flex items-start gap-3"><FaBox className="text-orange-600 mt-1" />Available raw, roasted, salted & blanched</li>
                        <li className="flex items-start gap-3"><FaGlobeAsia className="text-orange-600 mt-1" />Ideal for retail, food industry, gifting & exports</li>
                        <li className="flex items-start gap-3"><FaHeart className="text-orange-600 mt-1" />Naturally grown & hygienically processed</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-orange-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-orange-700 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-orange-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 text-left bg-orange-100">Grade</th>
                                    <td className="p-4">California, Nonpareil, Medium, Supreme</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Origin</th>
                                    <td className="p-4">USA, India (Kashmir, Himachal)</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Shelf Life</th>
                                    <td className="p-4">12-18 months</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Packaging</th>
                                    <td className="p-4">10kg / 25kg vacuum, jute, or box packs</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-orange-100">Moisture</th>
                                    <td className="p-4">Below 6%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-orange-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 text-left bg-orange-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 579 kcal<br />
                                        Protein: 21g<br />
                                        Fat: 49g (mostly unsaturated)<br />
                                        Carbs: 22g<br />
                                        Fiber: 12g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-orange-100">Usage</th>
                                    <td className="p-4">
                                        Snacking, Baking, Sweets, Protein Bars, Gifting, Cooking
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaHeart className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Heart-Healthy</h4>
                </div>
                <div>
                    <FaBrain className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Brain Booster</h4>
                </div>
                <div>
                    <FaGlobeAsia className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Global Exports</h4>
                </div>
                <div>
                    <FaBox className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Secure Packaging</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-orange-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-orange-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-orange-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Almond;
